import React from 'react';

import { GrupoEmailsFormComp, GrupoEmailsListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function GrupoEmailsList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_GRUPO_EMAIL_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <GrupoEmailsListComp />
        </ListagemProvider>
    );
}

export function GrupoEmailsForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_GRUPO_EMAIL_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <GrupoEmailsFormComp />
        </FormProvider>
    );
}
